import { Component, Input, OnInit } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";

import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { LosService } from "../../_LOS/services/los.service";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { CommonFunctions } from "../../CommonComponent/function/commonfunctions";
import { MasterService } from "../../Shared/app.Masters.Service";
declare var $: any;
@Component({
    selector: "app-printwelcomeletter",
    templateUrl: "./printwelcomeletter.component.html",
    styleUrls: ["./printwelcomeletter.component.scss"],
    standalone: false
})
export class PrintwelcomeletterComponent implements OnInit {
  showSpinner: boolean = false;
  applicationDetail: any;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  @Input("applicationId") applicationId: any;
  templateData: any = "";
  content: SafeHtml;
  loading: boolean = false;
  dropdownLanguages = [];
  coborrower1Details = {};
  coborrower2Details = {};
  guaranter1Details? = {};
  guaranter2Details = {};
  Sanction_Conditions = [];
  LODData = [];
  ChargesBalance: any;
  customerReferenceDetails: any;
  customerSanctionConditionDetails: any;
  currentUser: any;
  constructor(
    private dataSharingService: DataSharingService,
    private _MasterService: MasterService,
    private route: ActivatedRoute,
    private encdec: EncrDecrService,
    private snackBar: MatSnackBar,
    private router: Router,
    private losService: LosService,
    private sanitizer: DomSanitizer,
    private _commonfunctions: CommonFunctions,
    private _QuickLoanService: QuickLoanService,
  ) {
    this.route.paramMap.subscribe((param: ParamMap) => {});
  }

  ngOnInit() {
    //Get All Letter Template Language
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

    this.LOS_GetSectionLatterDetailsViewModel();
  }

  LOS_GetSectionLatterDetailsViewModel() {
    this.loading = true;
    this._MasterService
      .Get_Template_Details({
        Loan_Id: this.applicationId,
      })
      .subscribe((res: any) => {
        this.loading = false;
        this.applicationDetail = res.Item1[0];
        this.coborrower1Details = res.Item2[0];
        this.coborrower2Details = res.Item2[1];
        this.guaranter1Details = res.Item3[0];
        this.guaranter2Details = res.Item3[1];
        this.ChargesBalance = res.Item4;
        this.customerReferenceDetails = res.Item8;
        this.customerSanctionConditionDetails = res.Item9;
        this.Get_Template_Type();
      });
  }

  OnClose() {
    $("#Welcomemodel").modal("hide");
  }
  printLetter() {
    this._commonfunctions.PrintDocuments(
      "pdfWelcomeDownload",
      "Welcome Letter",
      this.applicationDetail.Application_No
    );
  }
  downloadPdf() {
    // var data = document.getElementById('pdfSenctionDownload');
    var prtContent = document.getElementById("pdfWelcomeDownload");
    var WinPrint = window.open("", "", "letf=100,top=100,width=600,height=600");
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
  }

  //Get Requests

  Get_Template_Type() {
    this._MasterService
      .Get_Template_Type({
        Type: "welcomeletter",
        ProductId: parseInt(this.applicationDetail.ProductId),
      })
      .subscribe((x: any[]) => {
        this.dropdownLanguages = x;
      });
  }

  Get_Template(Id) {
    this.loading = true;
    this._MasterService
      .Get_Template_Data({
        Id: Id,
        ProductId: this.applicationDetail.ProductId,
      })
      .subscribe((res) => {
        // console.log("Response x",x);
        this.loading = false;
        this.templateData = res[0].TemplateData;

        //replace Main Borrower Details

        //replace Main Borrower Details
        this.templateData = this.templateData.replace(
          /\[Application_No\]/g,
          this.applicationDetail.Application_No == null
            ? ""
            : this.applicationDetail.Application_No
        );
  this.templateData = this.templateData.replace(
              /\[APR\]/g,
              this.applicationDetail.APR == null
                ? ""
                : this.applicationDetail.APR
            );
            this.templateData = this.templateData.replace(
              /\[Sanction_Date\]/g,
              this.applicationDetail.Sanction_Date == null
                ? ""
                : this.applicationDetail.Sanction_Date
            );
               this.templateData = this.templateData.replace(
              /\[Vehicle_Manufacture\]/g,
              this.applicationDetail.Vehicle_Manufacture == null
                ? ""
                : this.applicationDetail.Vehicle_Manufacture
            );
            this.templateData = this.templateData.replace(
              /\[Vehicle_Type\]/g,
              this.applicationDetail.Vehicle_Type == null
                ? ""
                : this.applicationDetail.Vehicle_Type
            );
            this.templateData = this.templateData.replace(
              /\[DPD\]/g,
              this.applicationDetail.DPD == null
                ? ""
                : this.applicationDetail.DPD
            );
             this.templateData = this.templateData.replace(
              /\[Last_Receipt_Date\]/g,
              this.applicationDetail.Last_Receipt_Date == null
                ? ""
                : this.applicationDetail.Last_Receipt_Date
            );
            this.templateData = this.templateData.replace(
              /\[Installment_Received\]/g,
              this.applicationDetail.Installment_Received == null
                ? ""
                : this.applicationDetail.Installment_Received
            );
            this.templateData = this.templateData.replace(
              /\[Borrower_DOB\]/g,
              this.applicationDetail.Borrower_DOB == null
                ? ""
                : this.applicationDetail.Borrower_DOB
            );
            this.templateData = this.templateData.replace(
              /\[Borrower_Gender\]/g,
              this.applicationDetail.Borrower_Gender == null
                ? ""
                : this.applicationDetail.Borrower_Gender
            ); 
            this.templateData = this.templateData.replace(
              /\[Borrower_MaritalStatus\]/g,
              this.applicationDetail.Borrower_MaritalStatus == null
                ? ""
                : this.applicationDetail.Borrower_MaritalStatus
            );
        this.templateData = this.templateData.replace(
          /\[Source_Type\]/g,
          this.applicationDetail.SourceType == null
            ? ""
            : this.applicationDetail.SourceType
        );

        this.templateData = this.templateData.replace(
          /\[Source_Name\]/g,
          this.applicationDetail.SourceName == null
            ? ""
            : this.applicationDetail.SourceName
        );

        this.templateData = this.templateData.replace(
          /\[Branch_Name\]/g,
          this.applicationDetail.BranchName == null
            ? ""
            : this.applicationDetail.BranchName
        );
        this.templateData = this.templateData.replace(
          /\[Property_Owner_Name\]/g,
          this.applicationDetail.Property_Owner_Name == null
            ? ""
            : this.applicationDetail.Property_Owner_Name
        );
        this.templateData = this.templateData.replace(
          /\[Loan_No\]/g,
          this.applicationDetail.Loan_No == null
            ? ""
            : this.applicationDetail.Loan_No
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Name\]/g,
          this.applicationDetail.Customer_Name == null
            ? ""
            : this.applicationDetail.Customer_Name
        );
        this.templateData = this.templateData.replace(
          /\[Father_Name\]/g,
          this.applicationDetail.Father_Name == null
            ? ""
            : this.applicationDetail.Father_Name
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Address\]/g,
          this.applicationDetail.Customer_Address == null
            ? ""
            : this.applicationDetail.Customer_Address
        );
        this.templateData = this.templateData.replace(
          /\[Customer_PhoneNo\]/g,
          this.applicationDetail.Customer_PhoneNo == null
            ? ""
            : this.applicationDetail.Customer_PhoneNo
        );
        this.templateData = this.templateData.replace(
          /\[Loan_Product\]/g,
          this.applicationDetail.Loan_Product == null
            ? ""
            : this.applicationDetail.Loan_Product
        );
        this.templateData = this.templateData.replace(
          /\[Loan_Amount\]/g,
          this.applicationDetail.Loan_Amount == null
            ? ""
            : this.applicationDetail.Loan_Amount
        );
        this.templateData = this.templateData.replace(
          /\[Overdue_Installment_No\]/g,
          this.applicationDetail.OverDUE_EMI == null
            ? ""
            : this.applicationDetail.OverDUE_EMI
        );
        this.templateData = this.templateData.replace(
          /\[Margin_Amount\]/g,
          this.applicationDetail.Margin_Amount == null
            ? ""
            : this.applicationDetail.Margin_Amount
        );
        this.templateData = this.templateData.replace(
          /\[Tenure_Month\]/g,
          this.applicationDetail.Tenure_Month == null
            ? ""
            : this.applicationDetail.Tenure_Month
        );
        this.templateData = this.templateData.replace(
          /\[No_Of_instalment\]/g,
          this.applicationDetail.No_Of_instalment == null
            ? ""
            : this.applicationDetail.No_Of_instalment
        );
        this.templateData = this.templateData.replace(
          /\[EMI_Amount\]/g,
          this.applicationDetail.EMI_Amount == null
            ? ""
            : this.applicationDetail.EMI_Amount
        );
        this.templateData = this.templateData.replace(
          /\[EMI_Advance\]/g,
          this.applicationDetail.EMI_Advance == null
            ? ""
            : this.applicationDetail.EMI_Advance
        );
        this.templateData = this.templateData.replace(
          /\[ROI\]/g,
          this.applicationDetail.ROI == null ? "" : this.applicationDetail.ROI
        );
        this.templateData = this.templateData.replace(
          /\[IRR\]/g,
          this.applicationDetail.IRR == null ? "" : this.applicationDetail.IRR
        );
        this.templateData = this.templateData.replace(
          /\[Monthly_IRR\]/g,
          this.applicationDetail.Monthly_IRR == null ? "" : this.applicationDetail.Monthly_IRR
        );
        this.templateData = this.templateData.replace(
          /\[Borrower_Age\]/g,
          this.applicationDetail.Borrower_Age == null ? "" : this.applicationDetail.Borrower_Age
        );
        this.templateData = this.templateData.replace(
          /\[Month\]/g,
          this.applicationDetail.IRR == null ? "" : this.applicationDetail.IRR
        );
        this.templateData = this.templateData.replace(
          /\[Date\]/g,
          this.applicationDetail.Date == null ? "" : this.applicationDetail.Date
        );
        this.templateData = this.templateData.replace(
          /\[Date_Of_EMI\]/g,
          this.applicationDetail.Date_Of_EMI == null
            ? ""
            : this.applicationDetail.Date_Of_EMI
        );
        this.templateData = this.templateData.replace(
          /\[Day_Of_EMI\]/g,
          this.applicationDetail.Day_Of_EMI == null
            ? ""
            : this.applicationDetail.Day_Of_EMI
        );
        this.templateData = this.templateData.replace(
          /\[EMI_Frequency\]/g,
          this.applicationDetail.EMI_Frequency == null
            ? ""
            : this.applicationDetail.EMI_Frequency
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Relation\]/g,
          this.applicationDetail.Customer_Relation == null
            ? ""
            : this.applicationDetail.Customer_Relation
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Tehsil\]/g,
          this.applicationDetail.Customer_Tehsil == null
            ? ""
            : this.applicationDetail.Customer_Tehsil
        );
        this.templateData = this.templateData.replace(
          /\[Customer_District\]/g,
          this.applicationDetail.Customer_District == null
            ? ""
            : this.applicationDetail.Customer_District
        );
        this.templateData = this.templateData.replace(
          /\[Customer_State\]/g,
          this.applicationDetail.Customer_State == null
            ? ""
            : this.applicationDetail.Customer_State
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Pin_Code\]/g,
          this.applicationDetail.Customer_Pin_Code == null
            ? ""
            : this.applicationDetail.Customer_Pin_Code
        );
        this.templateData = this.templateData.replace(
          /\[Exposure_Amount\]/g,
          this.applicationDetail.Exposure_Amount == null
            ? ""
            : this.applicationDetail.Exposure_Amount
        );
        this.templateData = this.templateData.replace(
          /\[Overdue_Amount\]/g,
          this.applicationDetail.Overdue_Amount == null
            ? ""
            : this.applicationDetail.Overdue_Amount
        );
        this.templateData = this.templateData.replace(
          /\[DisbursementAmount\]/g,
          this.applicationDetail.DisbursementAmount == null
            ? ""
            : this.applicationDetail.DisbursementAmount
        );
        this.templateData = this.templateData.replace(
          /\[DealerName\]/g,
          this.applicationDetail.DealerName == null
            ? ""
            : this.applicationDetail.DealerName
        );
        this.templateData = this.templateData.replace(
          /\[VehicleModel\]/g,
          this.applicationDetail.Vehicle_Model == null
            ? ""
            : this.applicationDetail.Vehicle_Model
        );
        this.templateData = this.templateData.replace(
          /\[SalesExecutive\]/g,
          this.applicationDetail.SalesExecutive == null
            ? ""
            : this.applicationDetail.SalesExecutive
        );
        this.templateData = this.templateData.replace(
          /\[AssetsValue\]/g,
          this.applicationDetail.Application_AssetCost == null
            ? ""
            : this.applicationDetail.Application_AssetCost
        );
        this.templateData = this.templateData.replace(
          /\[LTV\]/g,
          this.applicationDetail.LTV == null ? "" : this.applicationDetail.LTV
        );

        this.templateData = this.templateData.replace(
          /\[LoanDate\]/g,
          this.applicationDetail.Loan_Date == null
            ? ""
            : this.applicationDetail.Loan_Date
        );
        this.templateData = this.templateData.replace(
          /\[CloseDate\]/g,
          this.applicationDetail.LoanCloseDate == null
            ? ""
            : this.applicationDetail.LoanCloseDate
        );
        this.templateData = this.templateData.replace(
          /\[Total_Deduction\]/g,
          this.applicationDetail.Total_Deduction == null
            ? ""
            : this.applicationDetail.Total_Deduction
        );
        //new
        this.templateData = this.templateData.replace(
          /\[Expiry_Date\]/g,
          this.applicationDetail.Expiry_Date == null
            ? ""
            : this.applicationDetail.Expiry_Date
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Nach_Bank\]/g,
          this.applicationDetail.Customer_Nach_Bank == null
            ? ""
            : this.applicationDetail.Customer_Nach_Bank
        );

        this.templateData = this.templateData.replace(
          /\[Loan_Purpose\]/g,
          this.applicationDetail.Loan_Purpose == null
            ? ""
            : this.applicationDetail.Loan_Purpose
        );
        this.templateData = this.templateData.replace(
          /\[Loan_Amount_InWord\]/g,
          this.applicationDetail.Loan_Amount_InWord == null
            ? ""
            : this.applicationDetail.Loan_Amount_InWord
        );
        this.templateData = this.templateData.replace(
          /\[Property_Address\]/g,
          this.applicationDetail.Property_Address == null
            ? ""
            : this.applicationDetail.Property_Address
        );
        this.templateData = this.templateData.replace(
          /\[Type_of_Property\]/g,
          this.applicationDetail.Type_of_Property == null
            ? ""
            : this.applicationDetail.Type_of_Property
        );
        this.templateData = this.templateData.replace(
          /\[Nature_of_Property\]/g,
          this.applicationDetail.Nature_of_Property == null
            ? ""
            : this.applicationDetail.Nature_of_Property
        );
        this.templateData = this.templateData.replace(
          /\[Ownership_Type\]/g,
          this.applicationDetail.Ownership_Type == null
            ? ""
            : this.applicationDetail.Ownership_Type
        );

        this.templateData = this.templateData.replace(
          /\[Ownership_Document\]/g,
          this.applicationDetail.Ownership_Document == null
            ? ""
            : this.applicationDetail.Ownership_Document
        );
        this.templateData = this.templateData.replace(
          /\[Unit_of_Measurement\]/g,
          this.applicationDetail.Unit_of_Measurement == null
            ? ""
            : this.applicationDetail.Unit_of_Measurement
        );
        this.templateData = this.templateData.replace(
          /\[Total_Area\]/g,
          this.applicationDetail.Total_Area == null
            ? ""
            : this.applicationDetail.Total_Area
        );
        this.templateData = this.templateData.replace(
          /\[Constructed_Area\]/g,
          this.applicationDetail.Constructed_Area == null
            ? ""
            : this.applicationDetail.Constructed_Area
        );

        this.templateData = this.templateData.replace(
          /\[Engine_No\]/g,
          this.applicationDetail.Engine_No == null
            ? ""
            : this.applicationDetail.Engine_No
        );
        this.templateData = this.templateData.replace(
          /\[Chassis_No\]/g,
          this.applicationDetail.Chassis_No == null
            ? ""
            : this.applicationDetail.Chassis_No
        );
        this.templateData = this.templateData.replace(
          /\[Identification_1\]/g,
          this.applicationDetail.Identification_1 == null
            ? ""
            : this.applicationDetail.Identification_1
        );
        this.templateData = this.templateData.replace(
          /\[Identification_2\]/g,
          this.applicationDetail.Identification_2 == null
            ? ""
            : this.applicationDetail.Identification_2
        );
        this.templateData = this.templateData.replace(
          /\[Customer_Email\]/g,
          this.applicationDetail.Customer_Email == null
            ? ""
            : this.applicationDetail.Customer_Email
        );
        this.templateData = this.templateData.replace(
          /\[Customer_PanNo\]/g,
          this.applicationDetail.Customer_PanNo == null
            ? ""
            : this.applicationDetail.Customer_PanNo
        );
        this.templateData = this.templateData.replace(
          /\[Vehicle_Registation_No\]/g,
          this.applicationDetail.Vehicle_Registation_No == null
            ? ""
            : this.applicationDetail.Vehicle_Registation_No
        );
        this.templateData = this.templateData.replace(
          /\[Application_Date\]/g,
          this.applicationDetail.Application_Date == null
            ? ""
            : this.applicationDetail.Application_Date
        );
        this.templateData = this.templateData.replace(
          /\[Branch_Address\]/g,
          this.applicationDetail.Branch_Address == null
            ? ""
            : this.applicationDetail.Branch_Address
        );
        this.templateData = this.templateData.replace(
          /\[Customer_AadharNo\]/g,
          this.applicationDetail.Customer_AadharNo == null
            ? ""
            : this.applicationDetail.Customer_AadharNo
        );
        this.templateData = this.templateData.replace(
          /\[BackArea\]/g,
          this.applicationDetail.BackArea == null
            ? ""
            : this.applicationDetail.BackArea
        );
        this.templateData = this.templateData.replace(
          /\[FrontArea\]/g,
          this.applicationDetail.FrontArea == null
            ? ""
            : this.applicationDetail.FrontArea
        );
        this.templateData = this.templateData.replace(
          /\[LeftArea\]/g,
          this.applicationDetail.LeftArea == null
            ? ""
            : this.applicationDetail.LeftArea
        );
        this.templateData = this.templateData.replace(
          /\[RightArea\]/g,
          this.applicationDetail.RightArea == null
            ? ""
            : this.applicationDetail.RightArea
        );
        this.templateData = this.templateData.replace(
          /\[ValuationDoneBy\]/g,
          this.applicationDetail.ValuationDoneBy == null
            ? ""
            : this.applicationDetail.ValuationDoneBy
        );
        this.templateData = this.templateData.replace(
          /\[Property_Value\]/g,
          this.applicationDetail.Property_Value == null
            ? ""
            : this.applicationDetail.Property_Value
        );
        this.templateData = this.templateData.replace(
          /\[Valuer_Code\]/g,
          this.applicationDetail.Valuer_Code == null
            ? ""
            : this.applicationDetail.Valuer_Code
        );
        this.templateData = this.templateData.replace(
          /\[Property_City\]/g,
          this.applicationDetail.Property_City == null
            ? ""
            : this.applicationDetail.Property_City
        );
        //Replace Coborrower Details
        this.templateData = this.templateData.replace(
          /\[COBorrower_Name1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_Name"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Relation1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_Relation"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Address1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_Address"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_PhoneNo1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_PhoneNo"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Tehsil1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_Tehsil"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_District1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_District"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_State1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_State"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Pin_Code1\]/g,
          this.coborrower1Details
            ? this.coborrower1Details["Customer_Pin_Code"]
            : ""
        );
        this.templateData = this.templateData.replace(
              /\[CoBorrower_1_DOB\]/g,
              this.coborrower1Details
                ? this.coborrower1Details["Customer_DOB"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[CoBorrower_1_Gender\]/g,
              this.coborrower1Details
                ? this.coborrower1Details["Customer_Gender"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[CoBorrower_1_MaritalStatus\]/g,
              this.coborrower1Details
                ? this.coborrower1Details["Customer_MaritalStatus"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[CoBorrowerPan_No\]/g,
              this.coborrower1Details
                ? this.coborrower1Details["CoBorrowerPan_No"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[CoBorrowerAadhar_No\]/g,
              this.coborrower1Details
                ? this.coborrower1Details["CoBorrowerAadhar_No"]
                : ""
            );

        //Replace Coborrower Details

        this.templateData = this.templateData.replace(
          /\[COBorrower_Name2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_Name"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Relation2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_Relation"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Address2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_Address"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_PhoneNo2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_PhoneNo"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Tehsil2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_Tehsil"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_District2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_District"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_State2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_State"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[COBorrower_Pin_Code2\]/g,
          this.coborrower2Details
            ? this.coborrower2Details["Customer_Pin_Code"]
            : ""
        );
         this.templateData = this.templateData.replace(
              /\[CoBorrower_2_DOB\]/g,
              this.coborrower2Details
                ? this.coborrower2Details["Customer_DOB"]
                : ""
            );
         this.templateData = this.templateData.replace(
              /\[CoBorrower_2_Gender\]/g,
              this.coborrower2Details
                ? this.coborrower2Details["Customer_Gender"]
                : ""
            );
          this.templateData = this.templateData.replace(
              /\[CoBorrower_2_MaritalStatus\]/g,
              this.coborrower2Details
                ? this.coborrower2Details["Customer_MaritalStatus"]
                : ""
            );
         this.templateData = this.templateData.replace(
              /\[CoBorrowerPan_No_2\]/g,
              this.coborrower2Details
                ? this.coborrower2Details["CoBorrowerPan_No"]
                : ""
            );
         this.templateData = this.templateData.replace(
              /\[CoBorrowerAadhar_No_2\]/g,
              this.coborrower2Details
                ? this.coborrower2Details["CoBorrowerAadhar_No"]
                : ""
            );
        //Replace Guaranter1
        this.templateData = this.templateData.replace(
          /\[Guarantor_Name1\]/g,
          this.guaranter1Details ? this.guaranter1Details["Customer_Name"] : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Relation1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_Relation"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Address1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_Address"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_PhoneNo1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_PhoneNo"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Tehsil1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_Tehsil"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_District1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_District"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_State1\]/g,
          this.guaranter1Details ? this.guaranter1Details["Customer_State"] : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Pin_Code1\]/g,
          this.guaranter1Details
            ? this.guaranter1Details["Customer_Pin_Code"]
            : ""
        );
         this.templateData = this.templateData.replace(
              /\[Guarantor_1_DOB\]/g,
              this.guaranter1Details
                ? this.guaranter1Details["Customer_DOB"]
                : ""
            );
          this.templateData = this.templateData.replace(
              /\[Guarantor_1_Gender\]/g,
              this.guaranter1Details
                ? this.guaranter1Details["Customer_Gender"]
                : ""
            );
          this.templateData = this.templateData.replace(
              /\[Guarantor_1_MaritalStatus\]/g,
              this.guaranter1Details
                ? this.guaranter1Details["Customer_MaritalStatus"]
                : ""
            );
        //Replace Guaranter2

        this.templateData = this.templateData.replace(
          /\[Guarantor_Name2\]/g,
          this.guaranter2Details ? this.guaranter2Details["Customer_Name"] : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Relation2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_Relation"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Address2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_Address"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_PhoneNo2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_PhoneNo"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Tehsil2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_Tehsil"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_District2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_District"]
            : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_State2\]/g,
          this.guaranter2Details ? this.guaranter2Details["Customer_State"] : ""
        );
        this.templateData = this.templateData.replace(
          /\[Guarantor_Pin_Code2\]/g,
          this.guaranter2Details
            ? this.guaranter2Details["Customer_Pin_Code"]
            : ""
        );
        this.templateData = this.templateData.replace(
              /\[Guarantor_2_DOB\]/g,
              this.guaranter2Details
                ? this.guaranter2Details["Customer_DOB"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[Guarantor_2_Gender\]/g,
              this.guaranter2Details
                ? this.guaranter2Details["Customer_Gender"]
                : ""
            );
        this.templateData = this.templateData.replace(
              /\[Guarantor_2_MaritalStatus\]/g,
              this.guaranter2Details
                ? this.guaranter2Details["Customer_MaritalStatus"]
                : ""
            );
        if (this.Sanction_Conditions.length > 0) {
          var prtSanction = document.getElementById("SanctionPrint");
          console.log("prtSanctionprtSanction", prtSanction.innerHTML);
          this.templateData = this.templateData.replace(
            /\[Senction_Conditions\]/g,
            prtSanction.innerHTML
          );
        } else {
          this.templateData = this.templateData.replace(
            /\[Senction_Conditions\]/g,
            ""
          );
        }
        this.templateData = this.templateData.replace(
              /\[Current_User\]/g,
              this.currentUser.FullName
            );
        if (this.LODData.length > 0) {
          var prtLODPrint = document.getElementById("LODPrint");
          console.log("prtLODPrint", prtLODPrint.innerHTML);
          this.templateData = this.templateData.replace(
            /\[LOD\]/g,
            prtLODPrint.innerHTML
          );
        } else {
          this.templateData = this.templateData.replace(/\[LOD\]/g, "");
        }
        if (this.ChargesBalance && this.ChargesBalance.length > 0) {
          this.ChargesBalance.forEach((value, index) => {
            this.templateData = this.templateData.replace(value.Charges_Head, value.Balance ? value.Balance : "");

          })
        }

            console.log("Refernce Template Before Replace", this.templateData.includes('[Reference]'));
             if (this.customerReferenceDetails && this.customerReferenceDetails.length > 0) {
              const customerReferenceTable = this.buildCustomerReferenceTable(this.customerReferenceDetails);

              this.templateData = this.templateData.replace(
                /\[Reference\]/g,
                customerReferenceTable
              );
            } else {
              this.templateData = this.templateData.replace(
                /\[Reference\]/g,
                ""
              );
            }

        this.content = this.sanitizer.bypassSecurityTrustHtml(
          this.templateData
        );
        $("#Welcomemodel").modal("show");
        $("#Welcomemodel").css("z-index", "1050");

        //FORE SANCTION CONDITION
            console.log("Sanction Condition Template Before Replace", this.templateData.includes('[Sanction_Condition]'));
             if (this.customerSanctionConditionDetails && this.customerSanctionConditionDetails.length > 0) {
              const customerReferenceTable = this.buildCustoemrSanctionConditionTable(this.customerSanctionConditionDetails);

              this.templateData = this.templateData.replace(
                /\[Sanction_Condition\]/g,
                customerReferenceTable
              );
            } else {
              this.templateData = this.templateData.replace(
                /\[Sanction_Condition\]/g,
                ""
              );
            }

        this.content = this.sanitizer.bypassSecurityTrustHtml(
          this.templateData
        );
        $("#Welcomemodel").modal("show");
        $("#Welcomemodel").css("z-index", "1050");
      });
  }
  GetSanctionConditions() {
    this.Sanction_Conditions = [];
    this._QuickLoanService
      .QuickLoan_Get_Sanction_Conditions({ Loan_Id: this.applicationId })
      .subscribe((response: any) => {
        console.log(response);
        if (response.length > 0) {
          response.forEach((obj: any) => {
            if (
              this.Sanction_Conditions &&
              this.Sanction_Conditions.find((result) => result.Id === obj.Id)
            ) {
              this.Sanction_Conditions.find(
                (result) => result.Id === obj.Id
              ).Condition.push({ Detail: obj.Detail });
            } else {
              this.Sanction_Conditions.push({
                Id: obj.Id,
                Header: obj.Particulars,
                IsCompleted: obj.Is_Completed,
                Condition: [{ Detail: obj.Detail }],
              });
            }
          });
        }
      });
  }

  buildCustomerReferenceTable(data: any[]): string {
  if (!data || data.length === 0) return "";
  let html = `
    <table border="1" style="border-collapse: collapse; width: 100%; font-size: 14px; text-align: center;">
      <thead>
        <tr>
          <th>Ref Relation</th>
          <th>Reference Type</th>
          <th>Person Name</th>
          <th>Person Address</th>
          <th>Contact No</th>
          <th>Person Know Year</th>
        </tr>
      </thead>
      <tbody>
  `;

  data.forEach((row: any) => {
    html += `
      <tr>
        <td style="padding: 6px;">${row.CR_RelationName ?? ""}</td>
        <td style="padding: 6px;">${row.CR_ReferenceType ?? ""}</td>
        <td style="padding: 6px;">${row.CR_PersonName ?? ""}</td>
        <td style="padding: 6px;">${row.CR_PersonAddress ?? ""}</td>
        <td style="padding: 6px;">${row.CR_ContactNo ?? ""}</td>
        <td style="padding: 6px;">${row.CR_PersonKnowYear ?? ""}</td>
      </tr>
    `;
  });

  html += `</tbody></table>`;

  return html;
}

  buildCustoemrSanctionConditionTable(data: any[]): string {
  if (!data || data.length === 0) return "";
  const groups: any[] = [];
  const map = new Map<any, any[]>();
  data.forEach((row) => {
    const key = row.Sanction_Id;
    if (!map.has(key)) {
      map.set(key, []);
      groups.push({ rows: map.get(key)! });
    }
    map.get(key)!.push(row);
  });

  let html = `
    <table border="1" style="border-collapse: collapse; width: 100%; font-size: 14px; text-align: center; border: 1px solid black;">
      <colgroup>
        <col style="width: 25%;">
        <col style="width: 75%;">
      </colgroup>
      <thead>
        <tr>
          <th style="border: 1px solid black; padding: 6px;">Header</th>
          <th style="border: 1px solid black; padding: 6px;">Detail</th>
        </tr>
      </thead>
      <tbody>
  `;

  groups.forEach((group) => {
    const rowspan = group.rows.length;
    group.rows.forEach((row: any, idx: number) => {
      html += `<tr>`;
      if (idx === 0) {
        html += `<td style="border: 1px solid black; padding: 6px;" rowspan="${rowspan}">${row.Header ?? ""}</td>`;
      }
      html += `<td style="border: 1px solid black; padding: 6px;">${row.Detail ?? ""}</td>`;
      html += `</tr>`;
    });
  });

  html += `</tbody></table>`;

  return html;
}
}
